module.exports = __webpack_public_path__ + "img/ic_20_report_white.35871854.svg";